import { Icon } from "@progress/kendo-react-common";
import { MultiSelectChangeEvent } from "@progress/kendo-react-dropdowns";
import {
  InputSuffix,
  TextBox,
  TextBoxChangeEvent,
} from "@progress/kendo-react-inputs";
import {
  TabStrip,
  TabStripSelectEventArguments,
  TabStripTab,
} from "@progress/kendo-react-layout";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router";
import Acheteurs from "../../../components/Acheteurs";
import { CheckIds } from "../../../constante/checkIds";
import useUrlParamsHandler from "../../../hooks/useUrlParamsHandler";
import { Activite } from "../../../models/Activite";
import { Banniere } from "../../../models/Banniere";
import { Collection } from "../../../models/Collection";
import { Division } from "../../../models/Division";
import { Fournisseur } from "../../../models/Fournisseur";
import { Magasin } from "../../../models/Magasin";
import { Section } from "../../../models/Section";
import { Statut } from "../../../models/Statut";
import { User } from "../../../models/User";
import { planoAPI } from "../../../redux/features/cache";
import { useAppDispatch } from "../../../redux/store";
import { CustomTreeView } from "./CustomTreeView";

export interface IHeaderPlanoProps {
  allMag: Magasin[];
  allBan: Banniere[];
  allDiv: Division[];
  users: User[];
  statuts: Statut[];
  acc: Activite[];
  div: Division[];
  allCollections: Collection[];
  collection: Collection[];
  handleRech: any;
  setUser: any;
  user: User[];
  ban: Banniere[];
  mag: Magasin[];
  section: Section[];
  four: Fournisseur[];
  currentAcc: Activite[];
  rech: string;
  sections: Section[];
  statut: Statut[];
  fournisseurs: Fournisseur[];
  resetPage: () => void;
  bannieresChildren: any;
  divisionsChildren: any;
  fournisseursChildren: any;
  statutsChildren: any;
  activitesChildren: any;
  collectionsChildren: any;
  filteredResults: number;
}

enum Tabs {
  Bannieres = "BANNIERES",
  Magasins = "MAGASINS",
  Divisions = "DIVISIONS",
  Sections = "SECTIONS",
  Fournisseurs = "FOURNISSEURS",
  Statuts = "STATUTS",
  Activites = "ACTIVITES",
  Collections = "COLLECTIONS",
}

function HeaderPlano({
  allMag,
  allBan,
  div,
  allDiv,
  handleRech,
  acc,
  ban,
  mag,
  section,
  four,
  currentAcc,
  rech,
  statuts,
  statut,
  fournisseurs,
  users,
  user,
  setUser,
  sections,
  resetPage,
  bannieresChildren,
  divisionsChildren,
  fournisseursChildren,
  statutsChildren,
  activitesChildren,
  collectionsChildren,
  collection,
  allCollections,
  filteredResults,
}: IHeaderPlanoProps) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [selected, setSelected] = useState<number>(0);
  const [ptrField, setPtrField] = useState(rech);
  const urlParamsHandler = useUrlParamsHandler();
  const dispatch = useAppDispatch();
  const checkIdsConfig = useMemo(
    () =>
      new Map<
        string,
        { data: any[]; allData: any[]; key: string; children?: string }
      >([
        [
          Tabs.Bannieres,
          {
            data: ban,
            allData: allBan,
            key: CheckIds.Banniere,
            children: Tabs.Magasins,
          },
        ],
        [Tabs.Magasins, { data: mag, allData: allMag, key: CheckIds.Magasin }],
        [
          Tabs.Divisions,
          {
            data: div,
            allData: allDiv,
            key: CheckIds.Division,
            children: Tabs.Sections,
          },
        ],
        [
          Tabs.Sections,
          { data: section, allData: sections, key: CheckIds.Section },
        ],
        [
          Tabs.Fournisseurs,
          { data: four, allData: fournisseurs, key: CheckIds.Fournisseur },
        ],
        [
          Tabs.Statuts,
          { data: statut, allData: statuts, key: CheckIds.Statut },
        ],
        [
          Tabs.Activites,
          { data: currentAcc, allData: acc, key: CheckIds.Activite },
        ],
        [
          Tabs.Collections,
          {
            data: collection,
            allData: allCollections,
            key: CheckIds.Collections,
          },
        ],
      ]),
    [
      acc,
      allBan,
      allCollections,
      allDiv,
      allMag,
      ban,
      collection,
      currentAcc,
      div,
      four,
      fournisseurs,
      mag,
      section,
      sections,
      statut,
      statuts,
    ]
  );

  useEffect(() => {
    searchParams.delete("applicatauthtoken");
    searchParams.delete("token");
    searchParams.delete("user");
    setSearchParams(searchParams);
  }, []);

  const handleChange = useCallback((event: TextBoxChangeEvent) => {
    setPtrField(event.target.value as string);
  }, []);

  const handleSelect = useCallback((e: TabStripSelectEventArguments) => {
    setSelected(e.selected);
  }, []);

  const onAcheteurChange = useCallback(
    (event: MultiSelectChangeEvent) => {
      let user = event.value.map((obj: User) => obj.usr_cd).join(",");
      resetPage();
      setUser(user);
      urlParamsHandler.setParamsToUrl("acht", user !== undefined ? user : "");
    },
    [resetPage, setUser, urlParamsHandler]
  );

  const getCheckIds = useCallback(
    (tabName: string): string[] => {
      const ids: string[] = [];

      const configs = checkIdsConfig.get(tabName);

      configs?.data.forEach((d) => {
        let value = configs?.allData.find(
          (a) => a[configs.key] === d[configs.key]
        );

        if (value) {
          ids.push(value[configs.key]);
        }
      });

      let childIds: string[] = [];
      if (configs?.children) {
        childIds = getCheckIds(configs.children);
      }

      return ids.concat(childIds);
    },
    [checkIdsConfig]
  );

  return (
    <div className="k-d-flex k-flex-column k-h-full k-gap-1">
      <TextBox
        value={ptrField}
        onChange={handleChange}
        placeholder="Rechercher un produit (#PTR)"
        suffix={() => (
          <InputSuffix>
            <Icon
              name="close"
              style={{ cursor: "pointer" }}
              onClick={() => {
                setPtrField("");
                resetPage();
                handleRech("");
              }}
            />
            <Icon
              name="search"
              style={{ cursor: "pointer" }}
              onClick={() => {
                resetPage();
                handleRech(ptrField);
              }}
            />
          </InputSuffix>
        )}
        className="global-search-input"
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            resetPage();
            handleRech((e.target as HTMLInputElement).value);
          }
        }}
      />
      <TabStrip
        selected={selected}
        onSelect={handleSelect}
        className="k-h-full k-overflow-auto">
        <TabStripTab title="Magasins" contentClassName="custom-tabstrip">
          <CustomTreeView
            data={allBan}
            children={bannieresChildren}
            checkIds={getCheckIds(Tabs.Bannieres)}
            useScroll={true}
            selectedTab={selected}
            invalidateQuery={() =>
              dispatch(planoAPI.util.invalidateTags(["bannieres"]))
            }
            totalProducts={filteredResults}
          />

        </TabStripTab>
        <TabStripTab title="Sec/Acht" contentClassName="custom-tabstrip">
          <CustomTreeView
            data={allDiv}
            children={divisionsChildren}
            acheteurs={
              <Acheteurs
                onAcheteurChange={onAcheteurChange}
                user={user}
                users={users}
              />
            }
            checkIds={getCheckIds(Tabs.Divisions)}
            useScroll={true}
            selectedTab={selected}
            invalidateQuery={() =>
              dispatch(planoAPI.util.invalidateTags(["divisions"]))
            }
            totalProducts={filteredResults}
          />
        </TabStripTab>
        <TabStripTab title="Fournisseurs" contentClassName="custom-tabstrip">
          <CustomTreeView
            data={fournisseurs}
            children={fournisseursChildren}
            checkIds={getCheckIds(Tabs.Fournisseurs)}
            useScroll={true}
            selectedTab={selected}
            invalidateQuery={() =>
              dispatch(planoAPI.util.invalidateTags(["fournisseurs"]))
            }
            totalProducts={filteredResults}
          />
        </TabStripTab>
        <TabStripTab title="Statuts" contentClassName="custom-tabstrip">
          <CustomTreeView
            data={statuts}
            children={statutsChildren}
            checkIds={getCheckIds(Tabs.Statuts)}
            useScroll={true}
            selectedTab={selected}
            invalidateQuery={() =>
              dispatch(planoAPI.util.invalidateTags(["statuts"]))
            }
          />
        </TabStripTab>
        <TabStripTab title="Activités" contentClassName="custom-tabstrip">
          <CustomTreeView
            data={acc}
            children={activitesChildren}
            checkIds={getCheckIds(Tabs.Activites)}
            useScroll={true}
            selectedTab={selected}
            invalidateQuery={() =>
              dispatch(planoAPI.util.invalidateTags(["activites"]))
            }
            totalProducts={filteredResults}
          />
        </TabStripTab>
        <TabStripTab title="Collections" contentClassName="custom-tabstrip">
          <CustomTreeView
            data={allCollections}
            children={collectionsChildren}
            checkIds={getCheckIds(Tabs.Collections)}
            useScroll={true}
            selectedTab={selected}
            invalidateQuery={() =>
              dispatch(planoAPI.util.invalidateTags(["collections"]))
            }
            totalProducts={filteredResults}
          />
        </TabStripTab>
      </TabStrip>
    </div>
  );
}

export default React.memo(HeaderPlano);
